import { Outlet, Navigate } from 'react-router-dom';
import Header from '../header/Header';
import PageNameAndSearch from '../PageNameAndSearchSection/pageNameAndSearch';
import { useState, useEffect } from 'react';
import { useUser } from './useUser';
import { useToken } from './useToken';
import {
  isTokenInitialized,
  getInitializationPromise,
} from '../../util/tokenManager';
import GradientLogo from '../../../public/icons/GradientLogo';

export default function PrivateRoutes() {
  const [navClassList, setNavClassList] = useState([]);
  const [placeholderToggle, setPlaceholderToggle] = useState(
    'page-name-and-search-placeholder'
  );
  const [isLoading, setIsLoading] = useState(false);

  const [token] = useToken();
  const user = useUser();

  useEffect(() => {
    // Wait for token initialization to complete
    const waitForInit = async () => {
      if (!isTokenInitialized() && !token) {
        setIsLoading(true);

        // Wait for initialization promise to complete
        const initPromise = getInitializationPromise();
        if (initPromise) {
          try {
            await initPromise;
          } catch (error) {
            // Initialization failed, user not logged in
          }
        }

        setIsLoading(false);
      } else {
        // If already initialized or have token, no loading needed
        setIsLoading(false);
      }
    };

    waitForInit();
  }, [token]);

  // Show loading screen during token initialization or if we're waiting for user data
  if (isLoading && !token && !isTokenInitialized()) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          flexDirection: 'column',
        }}>
        <GradientLogo svgClass={'splash-logo'} />
        <div style={{ marginTop: '20px', fontSize: '18px' }}>Loading...</div>
      </div>
    );
  }

  // If token is initialized but still no user and no token, redirect to public
  if (isTokenInitialized() && !user && !token) {
    return <Navigate to='/swapandtop/posts' replace />;
  }

  // If token exists but user is still null (during decode), show loading
  if (token && !user) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          flexDirection: 'column',
        }}>
        <GradientLogo svgClass={'splash-logo'} />
        <div style={{ marginTop: '20px', fontSize: '18px' }}>Loading...</div>
      </div>
    );
  }

  return (
    <>
      <div className='header-wrap'>
        <header className='main-header-wrap'>
          <Header />
        </header>
        <div className='main-page-name-and-search-wrap'>
          <div className={placeholderToggle}></div>
          <nav className={navClassList.join(' ')}>
            <PageNameAndSearch />
          </nav>
        </div>
      </div>
      <Outlet />
    </>
  );
}
